import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { Client } from "../types";

export const createClient = (userId: string, client: Client) =>
	webApiWithResponse<string>({
		method: "PUT",
		url: "listing/newclient",
		params: {
			userId
		},
		data: client
	});

export default createClient;
